import React from 'react'
import { translate, Trans } from 'react-i18next'

import LinkBlocksImg from '../components/LinkBlocksImg'
import ScrollToTopOnMount from '../components/ScrollToTopOnMount'

import vl1min from '../assets/img/vertical-landscaping/vl1min-min.jpg'
import vl2min from '../assets/img/vertical-landscaping/vl2min-min.jpg'
import vl3min from '../assets/img/vertical-landscaping/vl3min-min.jpg'
import vl4min from '../assets/img/vertical-landscaping/vl4min-min.jpg'
import vl5min from '../assets/img/vertical-landscaping/vl5min-min.jpg'
import vl6min from '../assets/img/vertical-landscaping/vl6min-min.jpg'
import vl7min from '../assets/img/vertical-landscaping/vl7min-min.jpg'
import vl8min from '../assets/img/vertical-landscaping/vl8min-min.jpg'
import vl9min from '../assets/img/vertical-landscaping/vl9min-min.jpg'



const T1 = (props) => {
  const arrImgmin = [ vl1min, vl2min, vl3min, vl4min, vl5min, vl6min, vl7min, vl8min, vl9min ]
  const arrImgfull = [
    { src: process.env.PUBLIC_URL + '/assets/vl1.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/vl2.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/vl3.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/vl4.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/vl5.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/vl6.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/vl7.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/vl8.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/vl9.jpg'}, 
  ]
  return(
    <LinkBlocksImg itemsmin={arrImgmin} itemsfull={arrImgfull} url='/' >
    <ScrollToTopOnMount />
      <Trans i18nKey='T1'>
        <p>
          Вертикальне озеленення (зелена стіна) – це<br/>
          - престижний атрибут<br/>
          - економія корисного простору<br/>
          - унікальний інтер’єр<br/>
          - здоровий мікроклімат<br/>
          - система автополиву<br/>
          - мінімальний догляд<br/>
          Зелена стіна – складна конструкція, яка складається з багатьох компонентів, таких як система для висадки рослин, система поливу, вид та розмір рослин. Створюється така конструкція індивідуально за розмірами і побажаннями кожного клієнта.
        </p>
        <p className="prise">
          Ціна фітостіни починається від 550$ за 1 м² і залежить від побажань клієнта та повного розміру конструкції. Чим більша загальна площа зеленої стіни, тим дешевша вартість 1 м².<br/>
          Термін виготовлення – не пізніше 30 календарних днів від дати отримання авансового платежу.
        </p>
      </Trans>
    </LinkBlocksImg>
  )
}

export default translate('translations')(T1)


// WEBPACK FOOTER //
// ./src/page/T1.jsx